import { ReactNode } from "react";
import { Button } from "@zapier/design-system";
import { Icon } from "@zapier/zinnia-icons";

type Props = {
  children: ReactNode;
};

export function CreateAssetLoadingButton({ children }: Props) {
  return (
    <Button
      variant="primary"
      size="compact"
      iconPosition="start"
      isPending={true}
    >
      <Icon name="formAdd" />
      {children}
    </Button>
  );
}
